import React from "react"

import LayoutGeneral from "components/layout-general-page"
import Layout from "components/layout"
import SEO from "components/seo"
import CartComp from "components/pages/carts"
import WishComp from "components/pages/carts/wishlist"
import { getServerAuthenticated } from "lib/utils/get-sever-authentication"
import { F_Q_WISHLIST, F_Q_CARTS, sendDatalayerProduct } from "lib/function"
import { TokenValidation } from "lib/function/token-validation"
import BlankStateWishlist from "components/pages/wishlist/blank-state"
import { useSelector } from "react-redux"
import icoBlank from "assets/img/icon/ico_add-cart-light.svg"

const CartsPage = ({ dataWishlist, locale, locales, carts, token }) => {
  //Utils
  const { wishlists } = useSelector((state) => state.auth)

  const [cartState, setCartState] = React.useState(carts)

  // For Datalayer ************************************************************
  const [hasSent, setHasSent] = React.useState(false)

  React.useEffect(() => {
    if (!hasSent && carts) {
      sendDatalayerProduct({
        event: "view_cart",
        data: {
          ...carts,
        },
        type: 3,
      })
      setHasSent(true)
    }
  }, [carts])
  // For Datalayer ************************************************************
  return (
    <>
      <SEO title="Carts" />
      <Layout>
        {cartState?.grand_total > 0 ? (
          <CartComp
            locale={locale}
            token={token}
            // dataWishlist={dataWishlist}
            carts={carts}
            locales={locales}
            setCartState={setCartState}
          />
        ) : (
          <BlankStateWishlist
            icon={icoBlank}
            title="Your Cart is Empty"
            subtext="Explore our products to start adding item(s) to cart."
          />
        )}
        {/* {dataWishlist?.length > 0 && (
          <WishComp data={dataWishlist} locale={locale} locales={locales} />
        )} */}
      </Layout>
    </>
  )
}

export default CartsPage

export const getServerSideProps = async (ctx) => {
  let { token, user_status } = await TokenValidation(ctx)
  let { locale, locales } = ctx
  let { data, errors } = await F_Q_CARTS({ lang: locale }, token)
  if (user_status) {
    // let {
    //   data: { wishlists },
    // } = await F_Q_WISHLIST({ lang: locale }, token)
    if (data) {
      return {
        props: {
          carts: data.carts,
          token,
          locale,
          // dataWishlist: wishlists,
        },
      }
    } else {
      return { notFound: true }
    }
  } else {
    if (!data) return { notFound: true }
    return { props: { carts: data.carts, locale, token } }
  }
}
